import { Box, Typography, Button } from '@mui/material';
import communityInitialImage from '/static/images/community_initial.png';

export const DisabledCommunityState = ({
  onEnable,
}: {
  onEnable: () => void;
}) => {
  return (
    <Box className="flex flex-col items-center bg-white sm:w-full md:w-[690px] rounded-[20px]">
      <Box className="flex flex-col gap-[14px] justify-between items-center h-full pb-[38px]">
        <Typography
          variant="h2"
          className="font-extrabold pt-[58px] sm:text-[28px]"
        >
          Ready For Community?
        </Typography>
        <Typography align="center" className="sm:w-[90%] md:w-[504px]">
          Community is a great way to engage with and retain subscribers as well
          as build relationships. Learn more{' '}
          <a
            href="https://playbookapp.io/handbook/community-tutorial-best-practices#best-practices-to-build-a-successful-community"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>{' '}
          about how the feature works and best practices to build a thriving
          community.
        </Typography>
        <img src={communityInitialImage} width={226} height={354} />
      </Box>
      <Box className="pb-[22px]">
        <Button variant="contained" className="font-normal" onClick={onEnable}>
          Enable community
        </Button>
      </Box>
    </Box>
  );
};
